import { useIntl } from 'react-intl';
import { Range } from 'sonata-react-components';

const DEFAULT_DEVIATION = 5;
const MIN_DEVIATION = -5;
const MAX_DEVIATION = 20;
const MARKS = { '-5': '-5', 0: '0', 10: '10', 15: '15', 20: '20', 5: '5' };

type Props = {
  id: string;
  onFilterStatus?: (state: { id: string; value: any }[]) => { id: string; value: any }[];
  value?: number;
};

export default function DeviationRange({ id, onFilterStatus, value }: Props) {
  const { formatMessage } = useIntl();

  const handleChange = (newValue: number | number[]) => {
    const threshold = Array.isArray(newValue) ? newValue[1] : newValue;
    onFilterStatus?.([{ id: 'deviation', value: threshold }]);
  };

  return (
    <Range
      id={`${id}_range`}
      max={MAX_DEVIATION}
      min={MIN_DEVIATION}
      onChange={handleChange}
      type="slider"
      value={value ?? DEFAULT_DEVIATION}
    >
      <Range.Box
        title={formatMessage({ defaultMessage: 'Deviation', id: 'deviatedLineItems.filters.deviation.label' })}
      >
        <Range.Bar marks={MARKS} />
      </Range.Box>
    </Range>
  );
}
